import React, { useEffect, useState } from "react"
import Chart from "react-apexcharts"
import { useSelector } from "react-redux"
import { isEmpty } from "lodash"

const SimCardsDistributed = () => {
  const { simcarddistribution } = useSelector(state => state.Dashboard)
  const [labels, setLabels] = useState([])
  const [seriesData, setSeriesData] = useState([])

  useEffect(() => {
    if (!isEmpty(simcarddistribution) && simcarddistribution[0]) {
      const lbls = simcarddistribution[0].Labels?.split(",") || []
      const data = simcarddistribution[0].Series?.split(",").map(Number) || []
      setLabels(lbls)
      setSeriesData(data)
    }
  }, [simcarddistribution])

  const options = {
    chart: {
      type: "bar",
      height: 300,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 6,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: labels,
      labels: {
        rotate: -45,
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      title: {
        text: "SIM Cards Distributed",
      },
    },
    colors: ["#00E396"],
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  const series = [
    {
      name: "SIM Cards",
      data: seriesData,
    },
  ]

  return (
    <div className="card p-3">
      <Chart options={options} series={series} type="bar" height={300} />
    </div>
  )
}

export default SimCardsDistributed
